<template>
  <div>
    <Card>
      <Table
        style="margin-top: 20px;"
        border
        :loading="loading"
        :columns="columns"
        :data="orders"
        :changePage="changePage"
        @on-row-click="onRowClick"
      ></Table>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { booleanChinese, podStatus, paymentChinese } from '@/libs/table-render'

export default {
  data () {
    return {
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: '订单号',
          key: 'code',
          width: 180,
          align: 'center'
        },
        {
          title: '支付状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: '付款方式',
          key: 'payment_method',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return podStatus(h, params.row.payment_method)
          }
        },
        {
          title: '会员名称',
          key: 'fresh_customer_username',
          width: 180,
          align: 'center'
        },
        {
          title: '会员手机',
          key: 'fresh_customer_mobile',
          width: 180,
          align: 'center'
        },
        {
          title: '商品总价',
          key: 'total',
          width: 100,
          align: 'center'
        },
        {
          title: '支付折扣',
          key: 'discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.discount + '%')
          }
        },
        {
          title: '是否抹零',
          key: 'small_discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.small_discount)
          }
        },
        {
          title: '折后价',
          key: 'discounted_total',
          width: 100,
          align: 'center'
        },
        {
          title: '实际支付',
          key: 'finish_total',
          width: 100,
          align: 'center'
        },
        {
          title: '用户支付',
          key: 'payment_total',
          width: 100,
          align: 'center'
        },
        {
          title: '找零',
          key: 'change_amount',
          width: 100,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.index({ customer_id: this.id })
  },
  computed: {
    ...mapGetters('order', ['orders', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('order', ['index']),
    ...mapMutations('order', ['changeQuery', 'resetQuery']),
    changePage (page) {
      this.changeQuery({ customer_id: this.id, page })
      this.index()
    },
    onRowClick (params) {
      this.$router.push(`/orders/${params.id}`)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
